// Generic order form class

import { Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

export class OrderForm {
  protected incomingData: any;
  protected orderForm: FormGroup;

  @Input() set data(incomingData: object) {
    this.incomingData = incomingData || {};

    let keys = Object.keys(this.orderForm.controls);
    for (let key of keys) {
      if (incomingData[key]) {
        if (key == "ingredients" && incomingData["type"] == "MC") {
          if (incomingData[key].length < 2) continue;
          this.orderForm.controls[key].patchValue(incomingData[key]);
        } else {
          this.orderForm.controls[key].setValue(incomingData[key]);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/forms/order-form/order-form.ts